import React, { useCallback } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import SideScroll from 'components/SideScroll'
import Breadcrumbs from 'components/Breadcrumbs'
import QuickassCategoryPicker from '../QuickassCategoryPicker'
import Search from '../SearchHeaderResponsive/Search'

const SearchBoxWrapper = styled.div`
  flex: 1 0;
  padding: 10px 16px;
  background-color: #4182c3;
`

const StyledSearch = styled(Search)`
  min-width: 200px;
  flex: 8;
  border-radius: 4px;
`

export const _SearchHeader = ({
  location,
  breadcrumbs,
  searchParamsActions,
  searchSubsetDescription,
  searchParametersDefinition,
  geoPref,
  filterQuery,
}) => {
  const search = queryString.parse(location.search)
  const haveCategory = Boolean(search && search.cg)
  const showPlaceholder = searchSubsetDescription ? `Sök inom ${searchSubsetDescription}` : ''

  const updateSearchParams = useCallback(
    (newSearchParams) => {
      searchParamsActions.select(
        {
          page: undefined,
          ...newSearchParams,
        },
        { updateListPathname: true },
      )
    },
    [searchParamsActions],
  )

  return (
    <>
      <SearchBoxWrapper>
        <StyledSearch
          key={`${queryString.stringify(search)}`}
          initialValue={search.q || ''}
          onSubmit={updateSearchParams}
          placeholder={haveCategory ? showPlaceholder : undefined}
        />
      </SearchBoxWrapper>
      <SideScroll listStyle="padding: 0 16px" listStyleLarge="padding: 0">
        <Breadcrumbs
          breadcrumbs={breadcrumbs}
          searchParametersDefinition={searchParametersDefinition}
          geoPref={geoPref}
          filterQuery={filterQuery}
        />
      </SideScroll>
      <QuickassCategoryPicker />
    </>
  )
}

_SearchHeader.propTypes = {
  location: PropTypes.object.isRequired,
  breadcrumbs: PropTypes.array,
  searchParamsActions: PropTypes.shape({
    select: PropTypes.func.isRequired,
  }),
  searchSubsetDescription: PropTypes.string,
  searchParametersDefinition: PropTypes.object.isRequired,
  geoPref: PropTypes.object,
  filterQuery: PropTypes.object,
}

export default withRouter(_SearchHeader)
